<form class="g-3 needs-validation" novalidate [formGroup]="formFields" (ngSubmit)="onSubmit()">
  <div class="row">
    <div [ngClass]="quote_type == 4 && mtaFinancials ? 'col-md-8' : 'col-md-12'">


      <!-- Policy period details -->
      <div class="form_sections">
        <h4><u>Period of cover from</u></h4>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group w-100">
              <input type="text" required name="inception_date" formControlName="inception_date"
                placeholder="Cover From" class="form-control form-control-sm datepicker" matInput
                (focus)="coverFromDatepicker.open()" [matDatepicker]="coverFromDatepicker"
                [min]="quote_type == 3?f.inception_date.value:minInceptionDate" [max]="maxInceptionDate"
                (dateChange)="onPolicyStartDateChange($event)"
                [ngClass]="{ 'is-invalid': (f.inception_date.touched || submitted) && f.inception_date.errors?.required }">
              <mat-datepicker-toggle [for]="coverFromDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #coverFromDatepicker></mat-datepicker>
              <div class="invalid-feedback"
                *ngIf="(f.inception_date.touched || submitted) && f.inception_date.errors?.required">
                Cover from is required.
              </div>
              <mat-error class="invalid-feedback"
                *ngIf="f.inception_date.hasError('matDatepickerMin') && submitted">Please
                select the valid date.</mat-error>

            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group w-100">
              <input type="text" required name="cover_to" formControlName="cover_to" placeholder="Cover To"
                class="form-control form-control-sm datepicker" matInput (focus)="coverToDatepicker.open()"
                [matDatepicker]="coverToDatepicker"
                [ngClass]="{ 'is-invalid': (f.cover_to.touched || submitted) && f.cover_to.errors?.required }">
              <mat-datepicker-toggle [for]="coverToDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #coverToDatepicker></mat-datepicker>
              <div class="invalid-feedback" *ngIf="(f.cover_to.touched || submitted) && f.cover_to.errors?.required">
                Cover to is required.
              </div>
            </div>
          </div>
          <div class="col-md-6" *ngIf="!isBroker">
            <label><u>Broker Details</u></label>
            <mat-form-field style="width: 93%">
              <mat-select formControlName="company_id" class="form-control form-control-sm" name="company_id"
                (selectionChange)="getBrokerCommission($event)"
                [ngClass]="{ 'is-invalid': (f.company_id.touched || submitted) && f.company_id.errors?.required  }">
                <mat-option [value]="">Select Broker</mat-option>
                <mat-option *ngFor="let brk of brokers" [value]="brk.id">
                  {{brk.name}}
                </mat-option>
              </mat-select>
              <div *ngIf="(f.company_id.touched || submitted) && f.company_id.errors?.required"
                class="invalid-feedback">
                Please select a broker.
              </div>
            </mat-form-field>
          </div>
        </div>
        <div class="row" *ngIf="quote_type == 3">
          <div class="col-md-6">
            <div class="form-group w-100">
              <label>MTA Effective Date</label><br>
              <input type="text" required name="effective_date" formControlName="effective_date"
                placeholder="MTA Effective Date" class="form-control form-control-sm datepicker" matInput
                (focus)="effectiveDateDatepicker.open()" [matDatepicker]="effectiveDateDatepicker"
                [min]="f.inception_date.value" [max]="f.cover_to.value"
                [ngClass]="{ 'is-invalid': (f.effective_date.touched || submitted) && f.effective_date.errors?.required }">
              <mat-datepicker-toggle [for]="effectiveDateDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #effectiveDateDatepicker></mat-datepicker>
              <div class="invalid-feedback"
                *ngIf="(f.effective_date.touched || submitted) && f.effective_date.errors?.required">
                Effective date is required.
              </div>
              <mat-error class="invalid-feedback" *ngIf="f.effective_date.hasError('matDatepickerMin')">Please
                select the valid date.</mat-error>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="quote_type == 4">
          <div class="col-md-6">
            <div class="form-group w-100">
              <label>Cancel Date</label><br>
              <input type="text" required name="effective_date" formControlName="effective_date"
                placeholder="Cancel Date" class="form-control form-control-sm datepicker" matInput
                (focus)="effectiveDateDatepicker.open()" [matDatepicker]="effectiveDateDatepicker"
                (dateChange)="onDateChange($event.value)" [min]="f.inception_date.value" [max]="f.cover_to.value"
                [ngClass]="{ 'is-invalid': (f.effective_date.touched || submitted) && f.effective_date.errors?.required }">
              <mat-datepicker-toggle [for]="effectiveDateDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #effectiveDateDatepicker></mat-datepicker>
              <div class="invalid-feedback"
                *ngIf="(f.effective_date.touched || submitted) && f.effective_date.errors?.required">
                Effective date is required.
              </div>
              <mat-error class="invalid-feedback" *ngIf="f.effective_date.hasError('matDatepickerMin')">Please
                select the valid date.</mat-error>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-3" *ngIf="quote_type >= 3">
            <mat-label>Policy Reason</mat-label>
            <mat-select formControlName="mta_reason_id" class="form-control form-control-sm" name="mta_reason_id"
              [ngClass]="{ 'is-invalid': (f.mta_reason_id.touched || submitted) && f.mta_reason_id.errors?.required }">
              <mat-option *ngFor="let rsn of policyReasons" [value]="rsn.id">
                {{rsn.reasons}}
              </mat-option>
              <mat-option [value]="'1'" *ngIf="quote_type == 3">Other</mat-option>
            </mat-select>
            <div *ngIf="(f.mta_reason_id.touched || submitted) && f.mta_reason_id.errors?.required"
              class="invalid-feedback">
              Please select a specific reason.
            </div>
          </div>
          <div class="col-md-12" *ngIf="quote_type == 3 && f.mta_reason_id.value == '1'">
            <div class="form-group">
              <textarea name="other_reason" formControlName="other_reason" placeholder="Please specify reason"
                class="form-control"
                [ngClass]="{ 'is-invalid': (f.other_reason.touched || submitted) && f.other_reason.errors?.required }">
      </textarea>
              <div *ngIf="(f.other_reason.touched || submitted) && f.other_reason.errors?.required"
                class="invalid-feedback">
                Please provide a specific reason.
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Company Or Individual details -->
      <div class="form_sections" formGroupName="proposer">
        <!------------- INDIVIDUAL PERSONAL DETAILS  ------------------>
        <div class="mt-3">
          <h6>Individual Details</h6>
          <div class="row">
            <div class="col-md-4" *ngIf="staticData">
              <mat-form-field class="w-100">
                <mat-label>Title</mat-label>
                <mat-select formControlName="title" class="form-control form-control-sm" name="title" required
                  [ngClass]="{ 'is-invalid': (proposerControls.title.touched || submitted) && proposerControls.title.errors?.required }">
                  <mat-option *ngFor="let title of staticData.title_options" [value]="title">
                    {{ title }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div class="invalid-feedback"
                *ngIf="(proposerControls.title.touched || submitted) && proposerControls.title.errors?.required">
                Title is required.
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mt-1">
                <input (input)="capitalizeField($event, 'first_name')" type="text" name="first_name"
                  placeholder="First Name" class="form-control form-control-sm" formControlName="first_name" required
                  [ngClass]="{ 'is-invalid': (proposerControls.first_name.touched || submitted) && proposerControls.first_name.errors?.required }">
                <div class="invalid-feedback"
                  *ngIf="(proposerControls.first_name.touched || submitted) && proposerControls.first_name.errors?.required">
                  First name is required.
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <input (input)="capitalizeField($event, 'last_name')" type="text" name="last_name"
                  placeholder="Last Name" class="form-control form-control-sm" formControlName="last_name">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group w-100 mt-2">
                <input type="text" required name="dob" formControlName="dob" placeholder="Date Of Birth"
                  class="form-control form-control-sm datepicker" matInput (focus)="dobDatepicker.open()"
                  [matDatepicker]="dobDatepicker" [max]="maxDob"
                  [ngClass]="{ 'is-invalid': (proposerControls.dob.touched || submitted) && proposerControls.dob.errors?.required }">
                <mat-datepicker-toggle [for]="dobDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #dobDatepicker></mat-datepicker>
                <div class="invalid-feedback"
                  *ngIf="(proposerControls.dob.touched || submitted) && proposerControls.dob.errors?.required">
                  DOB is required.
                </div>
              </div>
            </div>
          </div>
        </div>

        <!------------------ CONTACT DETAILS ------------------->
        <!-- <div class="form_sections" *ngIf="showContactDetails"> -->
        <div class="form_sections">
          <h6>Contact details</h6>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <input type="email" required name="email" formControlName="email" placeholder="Email"
                  class="form-control form-control-sm" matInput
                  [ngClass]="{ 'is-invalid': (proposerControls.email.touched || submitted) && proposerControls.email.errors?.required }">
                <div class="invalid-feedback"
                  *ngIf="(proposerControls.email.touched || submitted) && proposerControls.email.errors?.required">
                  Please enter your email address.
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <input type="text" required name="phone" formControlName="phone" placeholder="Phone"
                  class="form-control form-control-sm" matInput
                  [ngClass]="{ 'is-invalid': (proposerControls.phone.touched || submitted) && proposerControls.phone.errors?.required }">
                <div class="invalid-feedback"
                  *ngIf="(proposerControls.phone.touched || submitted) && proposerControls.phone.errors?.required">
                  Please enter your phone number.
                </div>
              </div>
            </div>
          </div>
          <h6 *ngIf="showContactDetails && !isBroker">Select your preferred ways to hear from us.</h6>
          <div class="row" *ngIf="showContactDetails && !isBroker">
            <div class="col-md-3">
              <mat-checkbox name="is_phone" class="mb-2" value="1" formControlName="is_phone"
                [checked]="proposerControls.is_phone.value == 1">
                Phone
              </mat-checkbox>
            </div>
            <div class="col-md-3">
              <mat-checkbox name="sms" value="1" formControlName="sms" [checked]="proposerControls.sms.value == 1"
                class="mb-2">
                Text
              </mat-checkbox>
            </div>
            <div class="col-md-3">
              <mat-checkbox name="is_email" value="1" formControlName="is_email"
                [checked]="proposerControls.is_email.value == 1" class="mb-2">
                Email
              </mat-checkbox>
            </div>
            <div class="col-md-3">
              <mat-checkbox name="post" value="1" formControlName="post" [checked]="proposerControls.post.value == 1"
                class="mb-2">
                Post
              </mat-checkbox>
            </div>
          </div>
        </div>


        <div>
          <h6 class="mt-3">Correspondence Address</h6>
          <div formGroupName="address">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" name="postcode" placeholder="Postcode" class="form-control form-control-sm"
                    (keyup)="postcodeLookup($event)"
                    pattern="^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$"
                    formControlName="postcode" [ngClass]="{ 'is-invalid': proposerAddressControls.postcode.invalid }"
                    [matAutocomplete]="auto" appUpperCase>
                  <div *ngIf="proposerAddressControls.postcode.errors?.pattern" class="invalid-feedback">
                    Invalid postcode.
                  </div>
                  <div class="invalid-feedback"
                    *ngIf="(proposerAddressControls.postcode.touched || submitted) && proposerAddressControls.postcode.errors?.required">
                    Please enter the postcode.
                  </div>
                  <div>
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option [value]="proposerAddressControls.postcode.value" (click)="onSelectAddress(adrs)"
                          *ngFor="let adrs of addresses">
                          {{ adrs.l || (adrs.formatted_address ? adrs.formatted_address.join(', ') : '') }}</mat-option>
                    </mat-autocomplete>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" name="line1" placeholder="Address Line 1" class="form-control form-control-sm"
                    formControlName="line1" required
                    [ngClass]="{ 'is-invalid': (proposerAddressControls.line1.touched || submitted) && proposerAddressControls.line1.errors?.required }">
                  <div class="invalid-feedback"
                    *ngIf="(proposerAddressControls.line1.touched || submitted) && proposerAddressControls.line1.errors?.required">
                    Please enter the address line 1.
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" name="line2" placeholder="Address Line 2" class="form-control form-control-sm"
                    formControlName="line2">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" name="line3" placeholder="Address Line 3" class="form-control form-control-sm"
                    formControlName="line3">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" name="county" placeholder="County" class="form-control form-control-sm"
                    formControlName="county" required
                    [ngClass]="{ 'is-invalid': (proposerAddressControls.county.touched || submitted) && proposerAddressControls.county.errors?.required }">
                  <div class="invalid-feedback"
                    *ngIf="(proposerAddressControls.county.touched || submitted) && proposerAddressControls.county.errors?.required">
                    Please enter the county.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!------------- CONVICTIONS  ------------------>

      </div>
      <!-- Controls -->
      <div class="row">
        <div class="col-md-6"></div>
        <div class="col-md-6 text-right"><button class="btn btn-success btn-sm">{{
            quote_type == 4
            ? 'Cancel'
            : (quote_type == 3 ? 'Proceed with MTA Changes' : 'Proceed')
            }}</button></div>
      </div>
    </div>
    <!-- Right Column - MTA Financial Summary Sidebar -->
    <div class="col-md-4" *ngIf="quote_type == 4 && mtaFinancials">
      <div class="mta-sidebar-panel">
        <div class="mta-sidebar-header">
          <h5 class="mb-0">Full Quote Details</h5>
          <i class="fas fa-chevron-up"></i>
        </div>
        <div class="mta-sidebar-content">

          <div class="mta-financial-item">
            <label>Policy premium</label>
            <span class="value">£{{ mtaFinancials.adjustment_display_amount | number:'1.2-2' }}</span>
          </div>

          <div class="mta-financial-item">
            <label>Insurance premium tax (12%)</label>
            <span class="value">£{{ mtaFinancials.adjustment_display_ipt | number:'1.2-2' }}</span>
          </div>

          <div class="mta-financial-item">
            <label>Peliwica Fee</label>
            <span class="value">£{{ mtaFinancials.broker_commission || 0 | number:'1.2-2' }}</span>
          </div>

          <div class="mta-financial-item total-cost-item">
            <label>Total cost of the policy</label>
            <span class="value">£{{ (mtaFinancials.adjustment_display_total) | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</form>